<script lang="ts" setup>
import { ChevronLeft, ChevronRight } from 'lucide-vue-next'
import { useTranslateKey } from '@/lib/utils'
import type { NavItems } from './sidebarConfig'

interface Props {
  navItem: NavItems
  isActive: boolean
  isSecondaryMenuItem: boolean
  hasOpenedSubmenu: boolean
  isDisabled?: boolean
}

defineProps<Props>()

const { translateKey } = useTranslateKey()
</script>

<template>
  <div
    class="group flex w-fit items-center gap-6"
    :class="{ 'opacity-70': isDisabled }"
    :data-testid="`sidebar-nav-${navItem.label}`"
    :data-tutorial-id="`tutorial.nav.${navItem.label}`"
    :data-tutorial-label="translateKey(navItem.label)"
    data-tutorial-role="link"
  >
    <h1
      class="relative flex items-center gap-2"
      :class="isSecondaryMenuItem ? 'font-mont-blanc-light text-base' : 'font-panama-regular'"
    >
      <span :class="{ 'cursor-not-allowed': isDisabled, 'cursor-pointer': !isDisabled }">
        {{ translateKey(navItem.label) }}
      </span>
      <div
        class="bg-primary absolute -bottom-1 left-0 h-0.25 transition-all duration-300 ease-out"
        :class="[isActive ? 'w-full' : 'w-0 group-hover:w-full', isDisabled ? 'hidden' : '']"
      />
    </h1>
    <div v-if="!hasOpenedSubmenu">
      <ChevronRight v-if="navItem.subroutes" class="size-4 transition-all" />
    </div>
    <div v-else>
      <ChevronLeft v-if="navItem.subroutes" class="size-4 transition-all" />
    </div>
  </div>
</template>
